module.exports = __webpack_public_path__ + "img/remove.34edaf5e.svg";